import { render, staticRenderFns } from "./CreateEditModeloProjetoModal.vue?vue&type=template&id=4183df27&"
import script from "./CreateEditModeloProjetoModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditModeloProjetoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports